const e = "_innerWrapper_hcoow_1", r = "_eyebrowTitleWrapper_hcoow_10", t = "_title_hcoow_14", p = "_textAndButtonWrapper_hcoow_17", o = "_shapeWrapper_hcoow_21", n = {
  innerWrapper: e,
  eyebrowTitleWrapper: r,
  title: t,
  textAndButtonWrapper: p,
  shapeWrapper: o
};
export {
  n as default,
  r as eyebrowTitleWrapper,
  e as innerWrapper,
  o as shapeWrapper,
  p as textAndButtonWrapper,
  t as title
};
